import React from 'react';

export default class ScrollIntoView extends React.Component<{ alignToTop: boolean; id: string; offset: number }> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.scroll();
  }

  componentDidUpdate() {
    this.scroll();
  }

  scroll() {
    const { id, alignToTop, offset } = this.props;
    if (!id) {
      return;
    }

    const element = document.querySelector(id);
    if (element && element.scrollIntoView) {
      setTimeout(() => {
        element.scrollIntoView(alignToTop || true);
        window.scrollBy(0, offset);
      }, 0);
    }
  }

  render() {
    return this.props.children ? this.props.children : null;
  }
}

export function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export const withScroll = (options: { offset?: number }) => (Component) => {
  const WithScroll = (props) => (
    <ScrollIntoView id={props && props.location && props.location.hash} alignToTop={true} offset={options.offset || 0}>
      <Component {...props} />
    </ScrollIntoView>
  );

  WithScroll.displayName = `withScroll(${getDisplayName(Component)})`;

  return WithScroll;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/ScrollIntoView.tsx